import { RootState } from "StoreTypes";

export const fetchCFReportLoading = (state: RootState) =>
  state.reportService.isCFReportLoading;
export const fetchCFReportError = (state: RootState) =>
  state.reportService.cfReportError;
export const fetchMTMReportLoading = (state: RootState) =>
  state.reportService.isMTMReportLoading;
export const fetchMTMReportError = (state: RootState) =>
  state.reportService.mtmReportError;
export const fetchVARReportLoading = (state: RootState) =>
  state.reportService.isVARReportLoading;
export const fetchVARReportError = (state: RootState) =>
  state.reportService.varReportError;
export const fetchProjectedVARReportLoading = (state: RootState) =>
  state.reportService.isProjectedVARReportLoading;
export const fetchProjectedVARReportError = (state: RootState) =>
  state.reportService.projectedVarReportError;
export const fetchSlicesLoading = (state: RootState) =>
  state.reportService.isSlicesLoading;
export const fetchSlicesError = (state: RootState) =>
  state.reportService.slicesError;
export const fetchSummaryError = (state: RootState) =>
  state.reportService.summaryError;
export const fetchSummaryLoading = (state: RootState) =>
  state.reportService.isSummaryLoading;
export const fetchInstrumentLoading = (state: RootState) =>
  state.reportService.isInstrumentLoading;
export const fetchInstrumentError = (state: RootState) =>
  state.reportService.instrumentError;
export const fetchInstrumentSummaryLoading = (state: RootState) =>
  state.reportService.isInstrumentSummaryLoading;
export const fetchInstrumentSummaryError = (state: RootState) =>
  state.reportService.instrumentSummaryError;
export const fetchCorrespondentLoading = (state: RootState) =>
  state.reportService.isCorrespondentLoading;
export const fetchCorrespondentError = (state: RootState) =>
  state.reportService.correspondentError;
export const fetchCFReport = (state: RootState) => state.reportService.cfReport;
export const fetchMtmReport = (state: RootState) =>
  state.reportService.mtmReport;
export const fetchVarReport = (state: RootState) =>
  state.reportService.varReport;
export const fetchProjectedVarReport = (state: RootState) =>
  state.reportService.projectedVarReport;
export const fetchError = (state: RootState) => state.reportService.error;
export const fetchErrorDetails = (state: RootState) =>
  state.reportService.errorDetails;
export const fetchSlices = (state: RootState) => state.reportService.slices;
export const fetchAlerts = (state: RootState) => state.reportService.alerts;
export const fetchSummary = (state: RootState) => state.reportService.summary;
export const fetchInstrument = (state: RootState) =>
  state.reportService.instrument;
export const fetchInstrumentSummary = (state: RootState) =>
  state.reportService.instrumentSummary;
export const fetchSliceDetails = (state: RootState) =>
  state.reportService.slice;
export const fetchTkrCusip = (state: RootState) => state.reportService.tkrCusip;
export const fetchSummaryDate = (state: RootState) =>
  state.reportService.summaryDate;
export const fetchCorrespondent = (state: RootState) =>
  state.reportService.correspondent;
